import { merge } from 'lodash';
import { createContext } from 'react';
import { Colors } from '../colors';

/**
 * @deprecated Frozen for sc-77113 — do not add new usages. Theme via the
 * `data-theme` attribute + semantic CSS vars (`--theme-*` / `--lighthouse-*`) in
 * CSS modules instead of the React color-theme context. Existing usages are
 * being migrated off with the React Native zero migration.
 */
export interface ColorTheme {
  accent: string;
  accentInactive: string;
  grayBackground: string;
  error: {
    foreground: string;
    background: string;
    border: string;
  };
  highlightActive: string;
  highlightInactive: string;
  background: string;
  backgroundInactive: string;
  foregroundActive: string;
  foregroundInactive: string;
  listRow: {
    background: string;
  };
  input: {
    backgroundActive: string;
    backgroundInactive: string;
    foregroundActive: string;
    foregroundInactive: string;
    label: string;
    borderInactive: string;
    borderActive: string;
  };
  avatar: {
    background: string;
    foreground: string;
  };
  section: {
    border: string;
  };
}

/**
 * @deprecated Frozen for sc-77113 — do not add new usages. Theme via the
 * `data-theme` attribute + semantic CSS vars (`--theme-*` / `--lighthouse-*`) in
 * CSS modules instead of the React color-theme context. Existing usages are
 * being migrated off with the React Native zero migration.
 */
export const defaultTheme: ColorTheme = {
  accent: Colors.v2.green,
  accentInactive: Colors.v2.green30,
  grayBackground: Colors.v2.grayBackground,
  error: {
    foreground: Colors.v2.actionWarmRed,
    background: Colors.v2.actionTropicalRed10,
    border: Colors.v2.actionTropicalRed,
  },
  highlightActive: Colors.v2.green10,
  highlightInactive: Colors.v2.green10,
  background: Colors.v2.white,
  backgroundInactive: Colors.v2.gray05,
  foregroundActive: Colors.v2.purple,
  foregroundInactive: Colors.v2.gray50,
  listRow: {
    background: 'transparent',
  },
  input: {
    backgroundActive: Colors.v2.gray05,
    backgroundInactive: Colors.v2.gray05,
    foregroundActive: Colors.v2.purple,
    foregroundInactive: Colors.v2.gray50,
    label: Colors.v2.gray30,
    borderInactive: Colors.v2.gray10,
    borderActive: Colors.v2.green30,
  },
  avatar: {
    background: Colors.v2.purple50,
    foreground: Colors.v2.green,
  },
  section: {
    border: Colors.v2.gray05,
  },
};

/**
 * @deprecated Frozen for sc-77113 — do not add new usages. Theme via the
 * `data-theme` attribute + semantic CSS vars (`--theme-*` / `--lighthouse-*`) in
 * CSS modules instead of the React color-theme context. Existing usages are
 * being migrated off with the React Native zero migration.
 */
export const darkTheme: ColorTheme = {
  accent: Colors.v2.green,
  accentInactive: Colors.v2.green30,
  grayBackground: Colors.v2.grayBackground,
  error: {
    foreground: Colors.v2.actionWarmRed,
    background: Colors.v2.actionTropicalRed10,
    border: Colors.v2.gray10,
  },
  highlightActive: Colors.overlay.white20,
  highlightInactive: Colors.overlay.white10,
  background: Colors.v2.greenSecondary90,
  backgroundInactive: Colors.v2.greenSecondary90,
  foregroundActive: Colors.v2.white,
  foregroundInactive: Colors.v2.tertiarySlateGreen,
  listRow: {
    background: Colors.v2.greenSecondary90,
  },
  input: {
    backgroundActive: Colors.overlay.white90,
    backgroundInactive: Colors.overlay.white30,
    foregroundActive: Colors.v2.purple,
    foregroundInactive: Colors.v2.purple,
    label: Colors.overlay.white30,
    borderInactive: Colors.v2.gray10,
    borderActive: Colors.v2.green30,
  },
  avatar: {
    background: Colors.overlay.white20,
    foreground: Colors.v2.green,
  },
  section: {
    border: Colors.v2.white,
  },
};

/**
 * @deprecated Frozen for sc-77113 — do not add new usages. Theme via the
 * `data-theme` attribute + semantic CSS vars (`--theme-*` / `--lighthouse-*`) in
 * CSS modules instead of the React color-theme context. Existing usages are
 * being migrated off with the React Native zero migration.
 */
export const grayTheme: ColorTheme = merge({}, defaultTheme, {
  background: Colors.v2.gray05,
  highlightActive: Colors.v2.gray10,
  highlightInactive: Colors.v2.gray10,
  listRow: {
    background: Colors.v2.gray05,
  },
});

/**
 * @deprecated Frozen for sc-77113 — do not add new usages. Theme via the
 * `data-theme` attribute + semantic CSS vars (`--theme-*` / `--lighthouse-*`) in
 * CSS modules instead of the React color-theme context. Existing usages are
 * being migrated off with the React Native zero migration.
 */
export const ColorThemeContext = createContext<ColorTheme>(defaultTheme);
